export default __webpack_public_path__ + "static/media/graphing-blue.71d624ab.svg";